import type { StateCreator } from 'zustand';

export interface NavigationSlice {
  // State
  currentStep: number;
  maxSteps: number;

  // Computed getters (calculated during render, not stored)
  // These will be calculated in components/hooks, not stored here

  // Actions (stable functions)
  goToStep: (step: number) => void;
  goNext: () => void;
  goBack: () => void;
  setMaxSteps: (max: number) => void;
  reset: () => void;
}

const initialState = {
  currentStep: -1,
  maxSteps: 0,
};

export const createNavigationSlice: StateCreator<
  NavigationSlice,
  [],
  [],
  NavigationSlice
> = (set, get) => ({
  ...initialState,

  goToStep: (step) => {
    const { maxSteps } = get();
    // Clamp step between -1 and maxSteps - 1
    const clampedStep = Math.max(-1, Math.min(step, maxSteps - 1));
    set({ currentStep: clampedStep });
  },

  goNext: () => {
    const { currentStep, maxSteps } = get();
    if (currentStep < maxSteps - 1) {
      set({ currentStep: currentStep + 1 });
    }
  },

  goBack: () => {
    const { currentStep } = get();
    if (currentStep > -1) {
      set({ currentStep: currentStep - 1 });
    }
  },

  setMaxSteps: (max) => {
    set({ maxSteps: max });
    // Adjust current step if it's out of bounds
    const { currentStep } = get();
    if (currentStep >= max) {
      set({ currentStep: Math.max(-1, max - 1) });
    }
  },

  reset: () => set(initialState),
});
